import { Link } from "react-router-dom";
import { ArrowLeft, XCircle } from "lucide-react";
import { useLanguage } from "@/i18n/LanguageContext";

export default function Cancel() {
  const { t } = useLanguage();
  return (
    <main data-testid="cancel-page" className="min-h-screen luxe-bg flex items-center justify-center px-6">
      <div className="max-w-xl w-full text-center fade-up">
        <XCircle className="w-16 h-16 text-[#7a716a] mx-auto mb-6" />
        <h1 className="font-display text-4xl sm:text-5xl text-[#f4ede0] mb-4">
          {t("cancel.title1")} <span className="italic copper-text">{t("cancel.title2")}</span>
        </h1>
        <p className="text-[#cbc1ad] mb-10 text-sm">{t("cancel.desc")}</p>
        <Link to="/#configurateur" className="btn-copper inline-flex items-center gap-3 px-8 py-4 text-sm uppercase tracking-[0.22em]">
          <ArrowLeft className="w-4 h-4" />
          {t("cancel.resume")}
        </Link>
      </div>
    </main>
  );
}
